import { CustomAccountSettingState } from "@electricMotorShop/Store/Data/AccountSettings/AccountSettingsReducer";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, GetCurrentAccount } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";

type XcAccountSettingsProps = Parameters<typeof GetCurrentAccount>[0];

function XcGetCurrentAccount(props: XcAccountSettingsProps) {
    const state = props.getState() as CustomAccountSettingState;
    const account = state.xcentiumAccountSettings.editingAccount;
    if (!account) {
        throw new Error("There was no current account when we are trying to save the current account");
    }
    props.account = account;
}

replaceInChain(chain, GetCurrentAccount, XcGetCurrentAccount);
